import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import React, { useContext, useState } from "react";
import { LinkedAccountsContext } from "../../../providers/LinkedAccountsProvider";
import PaymentCard from "./PaymentCard";
import { BookEZAccount, UserAccount } from "../BankingInterface";

interface LinkedAccountsContentProps {
  accounts?: BookEZAccount[];
}

const LinkedAccountsContent: React.FC<LinkedAccountsContentProps> = ({}) => {
  const { userAccounts, selectedAccountId, toggleAccountSelection } =
    useContext(LinkedAccountsContext);
  const [showAll, setShowAll] = useState(false);
  const cardsPerPage = 3;

  // Card types to match the image
  const cardTypes = ["credit", "debit", "transfer"];

  const displayedAccounts = showAll
    ? userAccounts
    : userAccounts?.slice(0, cardsPerPage);
  const hasMoreCards = userAccounts && userAccounts.length > cardsPerPage;

  return (
    <div className="w-full p-4">
      <div className="grid grid-cols-1 md:grid-cols-3! xl:grid-cols-4! gap-6">
        {displayedAccounts &&
          displayedAccounts.map((account: UserAccount, index) => (
            <div key={account.accountId} className="w-full">
              <PaymentCard
                account={account}
                cardType={
                  cardTypes[index % 3] as "credit" | "debit" | "transfer"
                }
                isSelected={
                  (selectedAccountId &&
                    selectedAccountId.includes(account.plaidAccountId)) ||
                  false
                }
                onSelect={() => toggleAccountSelection(account.plaidAccountId)}
              />
            </div>
          ))}
      </div>

      {hasMoreCards && (
        <div className="flex justify-center mt-8">
          <button
            onClick={() => setShowAll(!showAll)}
            className="flex items-center gap-2 px-6 py-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors text-gray-700 BookEZ_font_body_medium"
          >
            {showAll ? (
              <>
                Show Less
                <ChevronUpIcon className="w-5 h-5" />
              </>
            ) : (
              <>
                Show More
                <ChevronDownIcon className="w-5 h-5" />
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default LinkedAccountsContent;
